/**
 * InlineError — MCK-20260521-003 Tier 1.
 *
 * `role="alert"` so a failure that appears after a submit is announced without the reader
 * having to go looking for it. Two shapes: the default sits under a field, `variant="block"`
 * sits above a form and carries the failure the whole submit produced.
 */

import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';

import styles from './InlineError.module.css';

export interface InlineErrorProps {
  readonly id?: string;
  readonly variant?: 'inline' | 'block';
  readonly children: ReactNode;
}

export function InlineError({ id, variant = 'inline', children }: InlineErrorProps) {
  const classes = [styles.error, variant === 'block' ? styles.block : ''].filter(Boolean).join(' ');

  return (
    <p className={classes} id={id} role="alert">
      <AlertCircle className={styles.icon} size={14} strokeWidth={1.5} aria-hidden />
      <span>{children}</span>
    </p>
  );
}
